'use client';
import React, { useState } from 'react';
import CatAside from '../aside/CatAside';
import SortFilter from '../widgets/SortFilter';
import ArchiveContent from './ArchiveContent';
import Pagination from '../share/Pagination';
import ArchiveContentList from './ArchiveContentList';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function CategoryArchiveContent({
  categoryData,
  productsData,
  filters,
}) {
  const [openMobileSide, setOpenMobileSide] = useState(false);
  const isMobile = useIsMobile();
  const [isPriceList, setIsPriceList] = useState(false);

  return (
    <div className="category-archive-content flex pt-5 md:pt-10 ">
      <CatAside
        object={categoryData}
        openMobileSide={openMobileSide}
        onCloseModalHandler={() => setOpenMobileSide(false)}
      />
      <div className="category-page-content flex-1 max-w-full overflow-hidden">
        <SortFilter
          sort={filters?.sort}
          setOpenMobileSide={() => setOpenMobileSide(true)}
          isPriceList={isPriceList}
          setIsPriceList={setIsPriceList}
        />

        <div className={`${isPriceList ? 'block' : 'hidden'}`}>
          <ArchiveContentList
            products={productsData.data}
            priorityProducts={categoryData?.priority_products}
            pageTitle={categoryData?.title}
          />
        </div>

        <div className={`${!isPriceList ? 'block' : 'hidden'}`}>
          <ArchiveContent
            products={productsData.data}
            priorityProducts={categoryData?.priority_products}
          />
        </div>

        <Pagination
          itemsPerPage={20}
          totalItems={productsData.meta.total}
          currentPage={filters?.page ? parseInt(filters?.page) : 1}
        />
      </div>
    </div>
  );
}
